module.exports = __webpack_public_path__ + "img/Highland.198eefca.png";